export default __webpack_public_path__ + "static/media/SmashHaus_bg_hd.d8596ebf.png";